import { useFormContext, Controller } from "react-hook-form";
import RadioButtonGroup from "../../common/Jetlift/radio-button";
import Select from "../../common/Jetlift/Select";
import TextInput from "../../common/Jetlift/TextInput";
import Accordion from "../../common/accordion";
import RadioWithInput from "../../common/Jetlift/radio-button-input";
import Checkbox from "../../common/Jetlift/checkbox";
import useJetliftCollapseFacade from "../../../facade/jetlift/collapse/collapse.facade";
import Textarea from "../../common/Jetlift/textarea";
import { LABELS } from "../../../constants/labels/jetlift/jetlift.labels";
import useJetliftWellFacade from "../../../facade/jetlift/jetlift-input/well.facade";
import useJetliftOthersFacade from "../../../facade/jetlift/jetlift-input/others.facade";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import useJetliftTubingFacade from "../../../facade/jetlift/jetlift-input/tubing.facade";
import useJetliftFluidFacade from "../../../facade/jetlift/jetlift-input/fluid.facade";
import useJetPumpFacade from "../../../facade/jetlift/jetlift-input/jetPump.facade";
import { useEffect, useState } from "react";
import { defaultTubingWeight, yesNo } from "../../../constants/jetlift/jetlift";
import { casingWeightConstant } from "../../../utilities/CasingConstant";
import { generateRange, showToast } from "../../../utilities/commonUtilities";
import { Error } from "../../../assets/icons";
import { toast } from "react-toastify";

const useInputValidations = () => {
    const { getdefaultCollapse, handleCollapseChange } = useJetliftCollapseFacade();
    const {
        updateCasingOD,
        updateCasingWeight,
        updateLinerTop,
        updateLinerOD,
        updateLinerID,
        updateLinerWeight,
        updateTubing1Tubing,
        updateWellTrajectory,
        updateTubing1TubingOD,
        updateTubing1TubingWeight,
        updateTubing1TubingType,
        updateInstallationType,
        updateTubing2Tubing,
        updateTubing2TubingOD,
        updateTubing2TubingWeight,
        updateTubing2TubingType,
        clearCasing,
        casingWeightClear,
        tubing1ODClear,
        tubing2ODClear,
    } = useJetliftTubingFacade();
    const {
        updateCasingPressure,
        updateInflowTypeLstVal,
        updateSettingDepthReference,
        updateSettingDepth,
        updateStaticBottomHolePressureP,
        updateTestFlowRate,
        updateDesiredProductionRate,
        updateFlowingBottomHolePressureP,
        updateProductivityIndex,
        updateReservoirDatum,
        updateProducingFluidLevelFromSurfaceHead,
        updatePumpSettingVerticalDepth,
        updateTestFlowRateHead,
        updateStaticFluidLevelFromSurfaceHead,
        updateStaticBottomHolePressurePI,
        updateStaticFluidLevelFromSurfacePI,
        updateHiddenHeadPIIPType,
        updatePumpSuctionPressure,
    } = useJetliftWellFacade();
    const {
        updateSpGrWater,
        updateWaterCut,
        updateOilAPI,
        updateSpGrOil,
        updateGasProduction,
        updateGOR,
        updateGLR,
        updateSpGrGas,
        updateBubblePoint,
        updateBottomHoleTemp,
        updateSurfaceTemp,
        updateRegion,
        updateGasAvailability,
        updateHiddenBubblePoint,
        updateHiddenOilIpType,
        updateHiddenGasIp,
    } = useJetliftFluidFacade();
    const {
        updateManufacturerId,
        updateManufacturerName,
        updateMinPowerFluidPressure,
        updateMaxPowerFluidPressure,
        updateStepFluidRange,
        updateNozzleDiameterSize,
        updateNozzleValue,
        updateNozzleAreaSize,
        updateThroatDiameterSize,
        updateThroatValue,
        updateThroatAreaSize,
        updatePowerFluidType,
        updatePowerFluidDensity,
        updateOutputPressure,
        updateGasVent,
        loadNozzleArea,
        loadThroatArea,
        clearNozzleThroat,
    } = useJetPumpFacade();
    const {
        updateSupplyPower,
        updateSupplyVoltage,
        updateAvailableKVA,
        updateController,
        updateOxygen,
        updateNitrogen,
        updateH2S,
        updateCO2,
        updateCorrosion,
        updateParaffin,
        updateScale,
        updateSandSolids,
        updateViscosityEmulsion,
        updatePacker,
        updateChemical,
        updateYTool,
        updateScdaCompatibility,
        updatePressureSensor,
        updateNotes,
    } = useJetliftOthersFacade();
    const { tubingInput, units } = useAppSelector((state) => state?.jetlift?.tubing);
    const { wellInput } = useAppSelector((state) => state?.jetlift?.well);
    const { othersInput } = useAppSelector((state) => state?.jetlift?.others);
    const { fluidInput, region, regionList } = useAppSelector((state) => state?.jetlift?.fluid);
    const { jetPump } = useAppSelector((state) => state?.jetlift?.jetPump);
    const [wellTab, setWellTab] = useState({
        casingPressure: wellInput?.casingPressure || "",
        inflowType: wellInput?.inflowTypeLstVal?.toString() || "0",
        productivityIndex: wellInput?.piVal || "",
        staticBottomHolePressuePI: wellInput?.reservoirPressure || "",
        staticFluidLevelfromSurfacePI: wellInput?.staticFluidLvl ? +wellInput?.staticFluidLvl : "",
        desiredProdcutionRate: wellInput?.productionRate || "",
        pumpSuctionPressure: wellInput?.desiredPumpSuctionPressure || "",
        staticBottomHolePressureP: wellInput?.sbhpForPressre || "",
        flowingBottomHolePressureP: wellInput?.intakePressure || "",
        testFlowRateP: wellInput?.flowRate || "",
        staticFluidLevelFromSurfaceHead: wellInput?.staticFluidLvlForHd || "",
        producingFluidLevelSurfaceHead: wellInput?.prdcngFluidLvl || "",
        testFlowRateHead: wellInput?.flowRateForHd || "",
        settingDepthReference: wellInput?.pumpSetting || "",
        setDepth: wellInput?.setDepthType === 0 ? "1" : wellInput?.setDepthType?.toString(),
        pumpSettingVerticalDepth: wellInput?.tvd || "",
        reservoirDatum: wellInput?.perforation || "",
        flop: wellInput?.flop || "0",
    });

    const [fluidTab, setFluidTab] = useState({
        spGrWater: fluidInput?.spGrWater || "",
        waterCut: fluidInput?.waterCut || "",
        oilAPI: fluidInput?.oilAPI || "",
        spGrOil: fluidInput?.spGrOil || "",
        gasProduction: fluidInput?.gasProduction || "",
        gor: fluidInput?.gor || "",
        glr: fluidInput?.glr || "",
        spGrGas: fluidInput?.spGrGas || "",
        bubblePoint: fluidInput?.bubblePoint || "",
        bottomHoleTemp: fluidInput?.bottomHoleTemp || "",
        surfaceTemperature: fluidInput?.surfaceTemperature || "",
    });
    const [jetPumpTab, setJetPumpTab] = useState({
        nozzleDiameterSize: jetPump?.nozzleDiameterSize || "",
        nozzleAreaSize: jetPump?.nozzleAreaSize || "",
        throatDiameterSize: jetPump?.throatDiameterSize || "",
        throatAreaSize: jetPump?.throatAreaSize || "",
    });

    useEffect(() => {
        if (wellInput) {
            setWellTab((prev) => ({
                ...prev,
                casingPressure: wellInput?.casingPressure || "",
                inflowType: wellInput?.inflowTypeLstVal?.toString() || "0",
                productivityIndex: wellInput?.piVal || "",
                staticBottomHolePressuePI: wellInput?.reservoirPressure || "",
                staticFluidLevelfromSurfacePI: wellInput?.staticFluidLvl ? +wellInput?.staticFluidLvl : "",
                desiredProdcutionRate: wellInput?.productionRate || "",
                pumpSuctionPressure: wellInput?.desiredPumpSuctionPressure || "",
                staticBottomHolePressureP: wellInput?.sbhpForPressre || "",
                flowingBottomHolePressureP: wellInput?.intakePressure || "",
                testFlowRateP: wellInput?.flowRate || "",
                staticFluidLevelFromSurfaceHead: wellInput?.staticFluidLvlForHd || "",
                producingFluidLevelSurfaceHead: wellInput?.prdcngFluidLvl || "",
                testFlowRateHead: wellInput?.flowRateForHd || "",
                settingDepthReference: wellInput?.pumpSetting || "",
                setDepth: wellInput?.setDepthType === 0 ? "1" : wellInput?.setDepthType?.toString(),
                pumpSettingVerticalDepth: wellInput?.tvd || "",
                reservoirDatum: wellInput?.perforation || "",
                flop: wellInput?.flop || "0",
            }));
        };
    }, [wellInput]);

    useEffect(() => {
        if (fluidInput) {
            setFluidTab((prev) => ({
                ...prev,
                spGrWater: fluidInput?.spGrWater || "",
                waterCut: fluidInput?.waterCut || "",
                oilAPI: fluidInput?.oilAPI || "",
                spGrOil: fluidInput?.spGrOil || "",
                gasProduction: fluidInput?.gasProduction || "",
                gor: fluidInput?.gor || "",
                glr: fluidInput?.glr || "",
                spGrGas: fluidInput?.spGrGas || "",
                bubblePoint: fluidInput?.bubblePoint || "",
                bottomHoleTemp: fluidInput?.bottomHoleTemp || "",
                surfaceTemperature: fluidInput?.surfaceTemperature || "",
            }));
        };
    }, [fluidInput]);

    useEffect(() => {
        if (jetPump) {
            setJetPumpTab((prev) => ({
                ...prev,
                nozzleDiameterSize: jetPump?.nozzleDiameterSize || "",
                nozzleAreaSize: jetPump?.nozzleAreaSize || "",
                throatDiameterSize: jetPump?.throatDiameterSize || "",
                throatAreaSize: jetPump?.throatAreaSize || "",
            }));
        };
    }, [jetPump]);

    const wellIprTypes = {
        inflowTypeFields: [
            {
                name: "inflowType",
                label: `${LABELS?.inflowType}`,
                type: "select",
                onChange: (e: any) => {
                    setWellTab((prev) => ({ ...prev, inflowType: e }));
                    updateInflowTypeLstVal(e);
                },
                options: Array.isArray(wellInput?.inflowType) ? wellInput?.inflowType : [],
                value: wellTab?.inflowType || "0",
                enableSearch: false,
            },
        ],
        wellIPRPIInputs: [
            {
                label: `${LABELS?.productivityindex} (${LABELS?.pi})`,
                name: `${LABELS?.productivityindex} (Pi Val)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.productivityIndex && wellTab?.productivityIndex !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => {
                    setWellTab((prev) => ({ ...prev, productivityIndex: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.piVal)) return false;
                    updateProductivityIndex(e?.target?.value);
                },
                value: wellTab?.productivityIndex || "",
                unit: `${LABELS?.bpd}/${LABELS?.psi}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "0",
            },
            {
                label: "",
                type: "radioInput",
                name: `${LABELS?.staticBtmHolePressure} (PI)`,
                radioName: "ipr_pi",
                required: true,
                rules: {
                    required: (wellTab?.staticBottomHolePressuePI && wellTab?.staticBottomHolePressuePI !== 0) ? false : "Required",
                    allowDecimal: true,
                    allowNegative: true,
                },
                inputValue: wellTab?.staticBottomHolePressuePI || "",
                options: [
                    { label: `${LABELS?.staticBtmHolePressure}`, value: "0" },
                ],
                onRadioChange: (e: any) => { updateHiddenHeadPIIPType(e); },
                onInputChange: (e: any) => { setWellTab((prev) => ({ ...prev, staticBottomHolePressuePI: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.reservoirPressure)) return false;
                    updateStaticBottomHolePressurePI(e?.target?.value);
                },
                unit: `${LABELS?.psi}`,
                radioValue: wellInput?.hiddenPresHeadPIIPType,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "0",
                checked: wellInput?.hiddenPresHeadPIIPType === "0" ? true : false,
            },
            {
                label: "",
                type: "radioInput",
                name: `${LABELS?.staticFluidLevel} (PI)`,
                radioName: "ipr_pi",
                required: true,
                rules: {
                    required: (wellTab?.staticFluidLevelfromSurfacePI && wellTab?.staticFluidLevelfromSurfacePI !== 0) ? false : "Required",
                    allowDecimal: true,
                },
                inputValue: wellTab?.staticFluidLevelfromSurfacePI || "",
                options: [
                    { label: `${LABELS?.staticFluidLevel}`, value: "1" },
                ],
                onRadioChange: (e: any) => { updateHiddenHeadPIIPType(e); },
                onInputChange: (e: any) => { setWellTab((prev) => ({ ...prev, staticFluidLevelfromSurfacePI: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.staticFluidLvl)) return false;
                    updateStaticFluidLevelFromSurfacePI(e?.target?.value);
                },
                unit: `${LABELS?.ft}`,
                radioValue: wellInput?.hiddenPresHeadPIIPType,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "0",
                checked: wellInput?.hiddenPresHeadPIIPType === "1" ? true : false,
            },
        ],
        wellIPRPInpus: [
            {
                label: `${LABELS?.staticBtmHolePressure}`,
                name: `${LABELS?.staticBtmHolePressure} (P)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.staticBottomHolePressureP && wellTab?.staticBottomHolePressureP !== 0) ? false : "Required",
                    allowDecimal: true,
                },
                onChange: (e: any) => {
                    setWellTab((prev) => ({ ...prev, staticBottomHolePressureP: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.sbhpForPressre)) return false;
                    updateStaticBottomHolePressureP(e?.target?.value);
                },
                value: wellTab?.staticBottomHolePressureP || "",
                unit: `${LABELS?.psi}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "1",
            },
            {
                label: `${LABELS?.flowingBtmHolePressure}`,
                name: `${LABELS?.flowingBtmHolePressure} (P)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.flowingBottomHolePressureP && wellTab?.flowingBottomHolePressureP !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => {
                    setWellTab((prev) => ({ ...prev, flowingBottomHolePressureP: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.intakePressure)) return false;
                    updateFlowingBottomHolePressureP(e?.target?.value);
                },
                value: wellTab?.flowingBottomHolePressureP || "",
                unit: `${LABELS?.psi}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "1",
            },
            {
                label: `${LABELS?.testFlowRate}`,
                name: `${LABELS?.testFlowRate} (P)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.testFlowRateP && wellTab?.testFlowRateP !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => {
                    setWellTab((prev) => ({ ...prev, testFlowRateP: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.flowRate)) return false;
                    updateTestFlowRate(e?.target?.value);
                },
                value: wellTab?.testFlowRateP || "",
                unit: `${LABELS?.bpd}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "1",
            },
        ],
        wellIPRHeadInputs: [
            {
                label: `${LABELS?.staticFluidLevel}`,
                name: `${LABELS?.staticFluidLevel} (Head)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.staticFluidLevelFromSurfaceHead && wellTab?.staticFluidLevelFromSurfaceHead !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, staticFluidLevelFromSurfaceHead: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.staticFluidLvlForHd)) return false;
                    updateStaticFluidLevelFromSurfaceHead(e?.target?.value);
                },
                value: wellTab?.staticFluidLevelFromSurfaceHead || "",
                unit: `${LABELS?.ft}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "2",
            },
            {
                label: `${LABELS?.producingFluidLevel}`,
                name: `${LABELS?.producingFluidLevel} (Head)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.producingFluidLevelSurfaceHead && wellTab?.producingFluidLevelSurfaceHead !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, producingFluidLevelSurfaceHead: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.prdcngFluidLvl)) return false;
                    updateProducingFluidLevelFromSurfaceHead(e?.target?.value);
                },
                value: wellTab?.producingFluidLevelSurfaceHead || "",
                unit: `${LABELS?.ft}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "2",
            },
            {
                label: `${LABELS?.testFlowRate}`,
                name: `${LABELS?.testFlowRate} (Head)`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.testFlowRateHead && wellTab?.testFlowRateHead !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, testFlowRateHead: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.flowRateForHd)) return false;
                    updateTestFlowRateHead(e?.target?.value);
                },
                value: wellTab?.testFlowRateHead || "",
                unit: `${LABELS?.bpd}`,
                dependsOn: "inflowTypeLstVal",
                visibleWhen: "2",
            },
        ],
        desrdProductionFields: [
            {
                label: `${LABELS?.desiredProductionRate}`,
                type: "input",
                name: `${LABELS?.desiredProductionRate}`,
                required: true,
                rules: {
                    required: (wellTab?.desiredProdcutionRate && wellTab?.desiredProdcutionRate !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, desiredProdcutionRate: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.productionRate)) return false;
                    updateDesiredProductionRate(e?.target?.value);
                },
                value: wellTab?.desiredProdcutionRate || "",
                unit: `${LABELS?.bpd}`,
            },
            {
                label: `${LABELS?.reservoirDatum}`,
                name: `${LABELS?.reservoirDatum}`,
                type: "input",
                required: true,
                rules: {
                    required: (wellTab?.reservoirDatum && wellTab?.reservoirDatum !== 0) ? false : 'Required',
                    allowDecimal: true,
                    pattern: {
                        value: /^\d*\.?\d*$/,
                        message: `${LABELS?.numberError}`,
                    },
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, reservoirDatum: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.perforation)) return false;
                    updateReservoirDatum(e?.target?.value);
                },
                value: wellTab?.reservoirDatum || "",
                unit: `${LABELS?.ft1}`,
            },
            {
                label: `${LABELS?.pumpSuctionPressure}`,
                type: "input",
                name: `${LABELS?.pumpSuctionPressure}`,
                required: true,
                rules: {
                    required: (wellTab?.pumpSuctionPressure && wellTab?.pumpSuctionPressure !== 0) ? false : 'Required',
                    allowDecimal: true,
                },
                onChange: (e: any) => { setWellTab((prev) => ({ ...prev, pumpSuctionPressure: e?.target?.value })); },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(wellInput?.desiredPumpSuctionPressure)) return false;
                    updatePumpSuctionPressure(e?.target?.value);
                },
                value: wellTab?.pumpSuctionPressure || "",
                unit: `${LABELS?.psi}`,
            },
        ]
    };

    const fluidGasVolumeFields = {
        gasVolumeFields: [
            {
                label: "",
                type: "radioInput",
                name: `${LABELS?.gasProduction}`,
                radioName: "gasVolume_radio",
                required: true,
                rules: {
                    required: fluidTab?.gasProduction ? false : "Required",
                    allowDecimal: true,
                },
                options: [
                    { label: `${LABELS?.gasProduction}`, value: "0", default: fluidInput?.gasAvailblty === "1" ? true : false },
                ],
                inputValue: fluidTab?.gasProduction,
                radioValue: fluidInput?.hiddenGasIPType || "0",
                onRadioChange: (e: any) => { updateHiddenGasIp(e) },
                onInputChange: (e: any) => {
                    setFluidTab((prev) => ({ ...prev, gasProduction: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(fluidInput?.gasProduction)) return false;
                    updateGasProduction(e?.target?.value);
                },
                unit: `${LABELS?.gasProductionUnit}`,
                checked: fluidInput?.hiddenGasIPType === "0" ? true : false,
            },
            {
                label: "",
                type: "radioInput",
                name: `${LABELS?.gor}`,
                radioName: "gasVolume_radio",
                rules: {
                    required: "",
                    allowDecimal: true,
                },
                options: [
                    { label: `${LABELS?.gor}`, value: "1", default: fluidInput?.hiddenGasIPType === "1" ? true : false },
                ],
                inputValue: fluidTab?.gor,
                radioValue: fluidInput?.hiddenGasIPType || "1",
                onRadioChange: (e: any) => { updateHiddenGasIp(e) },
                onInputChange: (e: any) => {
                    setFluidTab((prev) => ({ ...prev, gor: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(fluidInput?.gor)) return false;
                    updateGOR(e?.target?.value);
                },
                unit: `${LABELS?.gorGlrUnit}`,
                checked: fluidInput?.hiddenGasIPType === "1" ? true : false,
            },
            {
                label: "",
                type: "radioInput",
                name: `${LABELS?.glr}`,
                radioName: "gasVolume_radio",
                rules: {
                    required: "",
                    allowDecimal: true,
                },
                options: [
                    { label: `${LABELS?.glr}`, value: "2", default: fluidInput?.hiddenGasIPType === "2" ? true : false },
                ],
                inputValue: fluidTab?.glr,
                radioValue: fluidInput?.hiddenGasIPType || "2",
                onRadioChange: (e: any) => { updateHiddenGasIp(e) },
                onInputChange: (e: any) => {
                    setFluidTab((prev) => ({ ...prev, glr: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(fluidInput?.glr)) return false;
                    updateGLR(e?.target?.value);
                },
                unit: `${LABELS?.gorGlrUnit}`,
                checked: fluidInput?.hiddenGasIPType === "2" ? true : false,
            },
        ],
        gasVolumeAdditionalFields: [
            {
                label: `${LABELS?.specificGravityOfGas}`,
                type: "input",
                name: `${LABELS?.specificGravityOfGas}`,
                unit: "",
                required: true,
                rules: {
                    required: fluidTab?.spGrGas ? false : "Required",
                    allowDecimal: true,
                },
                value: fluidTab?.spGrGas,
                dependsOn: "gasAvailblty",
                visibleWhen: "1",
                onChange: (e: any) => {
                    setFluidTab((prev) => ({ ...prev, spGrGas: e?.target?.value }));
                },
                onBlur: (e: any) => {
                    if (Number(e?.target?.value) === Number(fluidInput?.spGrGas)) return false;
                    updateSpGrGas(e?.target?.value);
                },
            },
            {
                label: `${LABELS?.gasCompressibility}`,
                type: "text",
                unit: "",
                readOnly: true,
                value: fluidInput?.gasCompressibility ?? "",
                dependsOn: "gasAvailblty",
                visibleWhen: "1",
            },
            {
                label: `${LABELS?.bubblePoint}`,
                type: "input",
                name: `${LABELS?.bubblePoint}`,
                unit: `${LABELS?.psi}`,
                required: !(fluidInput?.hdnAutoBBlPnt === "1" || fluidInput?.hdnAutoBBlPnt === true),
                rules: {
                    required: (fluidInput?.hdnAutoBBlPnt === "1" || fluidInput?.hdnAutoBBlPnt === true)
                        ? false
                        : (fluidInput?.bubblePoint ? false : "Required"),
                    allowDecimal: true,
                },
                value: fluidInput?.bubblePoint ?? "",
                disabled: fluidInput?.hdnAutoBBlPnt === "1" || fluidInput?.hdnAutoBBlPnt === true,
                dependsOn: "gasAvailblty",
                visibleWhen: "1",
                onChange: (e: any) => { updateBubblePoint(e?.target?.value) },
            },
            {
                label: `${LABELS?.maxBubblePoint}`,
                type: "checkbox",
                value: fluidInput?.hdnAutoBBlPnt === "1" || fluidInput?.hdnAutoBBlPnt === true,
                rules: {
                    required: "",
                },
                dependsOn: "gasAvailblty",
                visibleWhen: "1",
                onChange: (checked: any) => {
                    const isChecked = typeof checked === "boolean" ? checked : !!checked?.target?.checked;
                    updateHiddenBubblePoint(isChecked ? "1" : "0");
                    if (isChecked) {
                        updateBubblePoint("");
                    }
                },
            },
        ],
    };

    const sectionsData = {
        tubing: [
            {
                section: `${LABELS?.casing}`,
                fields: [
                    {
                        label: `${LABELS?.casingOD}`,
                        type: "select",
                        name: `${LABELS?.casingOD}`,
                        required: !(fluidInput?.hdnAutoGasCmpress === "1" || fluidInput?.hdnAutoGasCmpress === true),
                        rules: {
                            required: tubingInput?.casingOD ? false : 'Required',
                        },
                        onChange: (e: any) => {
                            const val = String(e);
                            if (Number(val) === Number(tubingInput?.casingOD)) return false;
                            if (val === "") {
                                clearCasing();
                            } else {
                                updateCasingOD(val);
                                const casingWeight = casingWeightConstant?.[val as keyof typeof casingWeightConstant] ?? "";
                                if (casingWeight) {
                                    updateCasingWeight(casingWeight);
                                }
                                casingWeightClear();
                            }
                        },
                        options: Array.isArray(tubingInput?.casingODList) ? tubingInput?.casingODList : [],
                        value: tubingInput?.casingOD?.toString() || "",
                        enableDeselect: true
                    },
                    {
                        label: `${LABELS?.casingWeight}`,
                        type: "select",
                        name: `${LABELS?.casingWeight}`,
                        required: true,
                        rules: {
                            required: tubingInput?.casingWeight ? false : 'Required',
                        },
                        onChange: (e: any) => { updateCasingWeight(e) },
                        value: tubingInput?.casingWeight?.toString() || "",
                        options: Array.isArray(tubingInput?.casingWeightList) ? tubingInput?.casingWeightList : []
                    },
                    {
                        label: `${LABELS?.casingID}`,
                        type: "text",
                        value: tubingInput?.casingID ?? "",
                        unit: units?.actNameCasingID || "in",
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.casingDriftID}`,
                        type: "text",
                        value: tubingInput?.casingDriftID ?? "",
                        unit: units?.actNameCasingID || "in",
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.pipeRoughness}`,
                        type: "text",
                        value: tubingInput?.pipeRoughness,
                        unit: "",
                        readOnly: true,
                    },
                ],
            },
            {
                section: `${LABELS?.liner}`,
                fields: [
                    {
                        label: `${LABELS?.linerOD}`,
                        type: "select",
                        rules: {
                            required: "",
                        },
                        onChange: (e: any) => {
                            if (Number(e) === Number(tubingInput?.linerOD)) return false;
                            updateLinerOD(e);
                        },
                        options: Array.isArray(tubingInput?.linerODList) ? tubingInput?.linerODList : [],
                        value: tubingInput?.linerOD?.toString() || "",
                    },
                    {
                        label: `${LABELS?.linerWeight}`,
                        type: "select",
                        rules: {
                            required: "",
                        },
                        onChange: (e: any) => {
                            if (Number(e) === Number(tubingInput?.linerWeight)) return false;
                            else if (e === "") updateLinerID("");
                            else updateLinerWeight(e);
                        },
                        options: Array.isArray(tubingInput?.linerWeightList) ? tubingInput?.linerWeightList : [],
                        value: tubingInput?.linerWeight?.toString() || "",
                    },
                    {
                        label: `${LABELS?.linerID}`,
                        type: "text",
                        value: tubingInput?.linerID,
                        unit: units?.actNameCasingID || "in",
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.linerTopMD}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,
                        },
                        onChange: (e: any) => { updateLinerTop(e?.target?.value); },
                        onBlur: (e: any) => { updateLinerTop(e?.target?.value); },
                        value: tubingInput?.linerTop?.toString() || "",
                        unit: units?.actNameLinerTop || "ft",
                    },
                ],
            },
        ],
        tubingInstallType: [
            {
                label: `${LABELS?.installType}`,
                type: "select",
                required: true,
                rules: {
                    required: tubingInput?.tubingInstallationType ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubingInstallationType)) return false;
                    else updateInstallationType(e);
                },
                options: [
                    { label: `${LABELS?.std}`, value: "0", default: tubingInput?.tubingInstallationType === "0" ? true : false },
                    { label: `${LABELS?.reverseFlow}`, value: "1", default: tubingInput?.tubingInstallationType === "1" ? true : false },
                    { label: `${LABELS?.parallel}`, value: "2", default: tubingInput?.tubingInstallationType === "2" ? true : false },
                    { label: `${LABELS?.concentric}`, value: "3", default: tubingInput?.tubingInstallationType === "3" ? true : false },
                ],
                value: tubingInput?.tubingInstallationType?.toString() || "0",
                enableSearch: false,
            },
        ],
        tubingParallelProductionFlow: [
            {
                label: `${LABELS?.porductionFlowId}`,
                type: "select",
                required: false,
                rules: {
                    required: "",
                },
                onChange: (e: any) => { },
                options: [],
                value: "",
            },
        ],
        tubing1Section: [
            {
                label: `${LABELS?.tubingOD}`,
                name: "Tubing1 tubing OD",
                type: "select",
                required: true,
                rules: {
                    required: tubingInput?.tubing1_tubingOD ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing1_tubingOD)) return false;
                    else if (e === "") tubing1ODClear();
                    else updateTubing1TubingOD(e);
                },
                options: Array.isArray(tubingInput?.tubingODList) ? tubingInput?.tubingODList : [],
                value: tubingInput?.tubing1_tubingOD || "",
            },
            {
                label: `${LABELS?.tubingType}`,
                type: "select",
                name: "Tubing1 tubing type upset",
                required: true,
                rules: {
                    required: tubingInput?.tubing1_tubingTypeUpset ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing1_tubingTypeUpset)) return false;
                    else {
                        updateTubing1TubingType(e);
                        e === "0" ? updateTubing1TubingWeight("") : updateTubing1TubingWeight(defaultTubingWeight?.find((tubing: any) => tubing?.value === tubingInput?.tubing1_tubingOD)?.label ?? "");
                    };
                },
                options: Array.isArray(tubingInput?.tubingTypeUpsetList) ? tubingInput?.tubingTypeUpsetList : [],
                value: tubingInput?.tubing1_tubingTypeUpset?.toString() || "1",
                enableSearch: false,
            },
            {
                label: `${LABELS?.tubingWeight}`,
                type: "select",
                name: "Tubing1 tubing weight",
                required: true,
                rules: {
                    required: tubingInput?.tubing1_tubingWeight ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing1_tubingWeight)) return false;
                    else updateTubing1TubingWeight(e)
                },
                options: Array.isArray(tubingInput?.tubing1WeightList) ? tubingInput?.tubing1WeightList : [],
                value: tubingInput?.tubing1_tubingWeight?.toString(),
            },
            {
                label: `${LABELS?.tubingID}`,
                type: "text",
                value: tubingInput?.tubing1_tubingID ?? "",
                unit: units?.actNameTubingID || "in",
                readOnly: true,
            },
            {
                label: `${LABELS?.tubing}`,
                type: "select",
                name: "Tubing1 tubing type",
                required: true,
                rules: {
                    required: tubingInput?.tubing1_tubingType ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing1_tubingType)) return false;
                    else updateTubing1Tubing(e)
                },
                options: Array.isArray(tubingInput?.tubingTypeList) ? tubingInput?.tubingTypeList : [],
                value: tubingInput?.tubing1_tubingType?.toString() || "120",
                enableSearch: false,
            },
        ],
        tubing2Section: [
            {
                label: `${LABELS?.tubingOD}`,
                name: "Tubing2 tubingOD",
                type: "select",
                required: true,
                rules: {
                    required: tubingInput?.tubing2_tubingOD ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing2_tubingOD)) return false;
                    else if (e === "") tubing2ODClear();
                    else updateTubing2TubingOD(e);
                },
                options: Array.isArray(tubingInput?.tubingODList) ? tubingInput?.tubingODList : [],
                value: tubingInput?.tubing2_tubingOD || "",
            },
            {
                label: `${LABELS?.tubingType}`,
                type: "select",
                name: "Tubing2 tubing type upset",
                required: true,
                rules: {
                    required: tubingInput?.tubing2_tubingTypeUpset ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing2_tubingTypeUpset)) return false;
                    else {
                        updateTubing2TubingType(e);
                        e === "0" ? updateTubing2TubingWeight("") : updateTubing2TubingWeight(defaultTubingWeight?.find((tubing: any) => tubing?.value === tubingInput?.tubing2_tubingOD)?.label ?? "");
                    }
                },
                options: Array.isArray(tubingInput?.tubingTypeUpsetList) ? tubingInput?.tubingTypeUpsetList : [],
                value: tubingInput?.tubing2_tubingTypeUpset?.toString() || "1",
                enableSearch: false,
            },
            {
                label: `${LABELS?.tubingWeight}`,
                type: "select",
                name: "Tubing2 tubing weight",
                required: true,
                rules: {
                    required: tubingInput?.tubing2_tubingWeight ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing2_tubingWeight)) return false;
                    else updateTubing2TubingWeight(e);
                },
                options: Array.isArray(tubingInput?.tubing2WeightList) ? tubingInput?.tubing2WeightList : [],
                value: tubingInput?.tubing2_tubingWeight?.toString(),
            },
            {
                label: `${LABELS?.tubingID}`,
                type: "text",
                value: tubingInput?.tubing2_tubingID ?? "",
                unit: units?.actNameTubingID || "in",
                readOnly: true,
            },
            {
                label: `${LABELS?.tubing}`,
                type: "select",
                name: "Tubing2 tubing type",
                required: true,
                rules: {
                    required: tubingInput?.tubing2_tubingType ? false : 'Required',
                },
                onChange: (e: any) => {
                    if (Number(e) === Number(tubingInput?.tubing2_tubingType)) return false;
                    else updateTubing2Tubing(e);
                },
                options: Array.isArray(tubingInput?.tubingTypeList) ? tubingInput?.tubingTypeList : [],
                value: tubingInput?.tubing2_tubingType?.toString() || "120",
                enableSearch: false,
            },
        ],
        tubingTrajectory: [
            {
                label: `${LABELS?.wellTrajectory}`,
                type: "select",
                rules: {
                    required: "",
                },
                onChange: ((e: any) => {
                    if (e === tubingInput?.wellTrajectory?.toString()) return false;
                    else updateWellTrajectory(e);
                }),
                options: Array.isArray(tubingInput?.wellTrajectoryList) ? tubingInput?.wellTrajectoryList : [],
                value: tubingInput?.wellTrajectory?.toString() || "1",
                dropdownDirection: "up",
                enableSearch: false,
            },
        ],
        well: [
            {
                section: `${LABELS?.surfaceConditions}`,
                fields: [
                    {
                        label: `${LABELS?.flowLinePressure}`,
                        name: "Flow line pressure",
                        type: "input",
                        rules: {
                            required: (wellTab?.casingPressure && wellTab?.casingPressure !== 0) ? false : 'Required',
                            allowDecimal: true,
                        },
                        required: true,
                        onChange: (e: any) => {
                            setWellTab((prev) => ({ ...prev, casingPressure: e?.target?.value }));
                        },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(wellInput?.casingPressure)) return false;
                            updateCasingPressure(e?.target?.value);
                        },
                        value: wellTab?.casingPressure || "",
                        unit: `${LABELS?.psi}`
                    },
                ],
            },
            {
                section: `${LABELS?.settingDepth}`,
                fields: [
                    // {
                    //     label: `${LABELS?.settingDepthRef}`,
                    //     name: "settingDepth",
                    //     type: "radio",
                    //     rules: {
                    //         required: wellTab?.setDepth ? false : "Required",
                    //     },
                    //     onChange: (e: any) => {
                    //         setWellTab((prev) => ({ ...prev, setDepth: e }));
                    //         updateSettingDepthReference(Number(e));
                    //     },
                    //     options: [
                    //         { label: `${LABELS?.intake}`, value: "1", default: wellTab?.setDepth === "1" ? true : false },
                    //         { label: `${LABELS?.setDepth}`, value: "2", default: wellTab?.setDepth === "2" ? true : false },
                    //     ],
                    //     direction: "row",
                    //     value: wellTab?.setDepth?.toString(),
                    // },
                    {
                        label: "Set depth",
                        type: "input",
                        name: "Setting depth",
                        required: true,
                        rules: {
                            required: (wellTab?.settingDepthReference && wellTab?.settingDepthReference !== 0) ? false : 'Required',
                            allowDecimal: true,
                            pattern: {
                                value: /^\d*\.?\d*$/,
                                message: `${LABELS?.numberError}`,
                            },
                        },
                        onChange: (e: any) => { setWellTab((prev) => ({ ...prev, settingDepthReference: e?.target?.value })); },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(wellInput?.pumpSetting)) return false;
                            updateSettingDepth(e?.target?.value);
                        },
                        value: wellTab?.settingDepthReference || "",
                        unit: `${LABELS?.ft1}`,
                    },
                    {
                        label: `${LABELS?.flop}`,
                        type: "text",
                        value: wellTab?.flop || "",
                        unit: `${LABELS?.ft1}`,
                        readOnly: true,
                    },
                ],
            },
        ],
        fluid: [
            {
                section: `${LABELS?.fluid}`,
                fields: [
                    {
                        label: `${LABELS?.spGrWater}`,
                        type: "input",
                        name: `${LABELS?.spGrWater}`,
                        value: fluidTab?.spGrWater || "",
                        unit: "",
                        required: true,
                        rules: {
                            required: fluidTab?.spGrWater ? false : "Required",
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            setFluidTab((prev) => ({ ...prev, spGrWater: e?.target?.value }));
                        },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(fluidInput?.spGrWater)) return false;
                            updateSpGrWater(e?.target?.value);
                        },
                    },
                    {
                        label: `${LABELS?.waterCut}`,
                        type: "input",
                        name: `${LABELS?.waterCut}`,
                        unit: `${LABELS?.percentage}`,
                        required: true,
                        rules: {
                            required: fluidTab?.waterCut ? false : "Required",
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            if (Number(e?.target?.value) <= 100) {
                                setFluidTab((prev) => ({ ...prev, waterCut: e?.target?.value }));
                            } else {
                                toast.error("Please provide value less than 100.", {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    icon: <Error color="#ffffff" />,
                                    style: {
                                        background: "#f04438",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontFamily: "Mulish",
                                        fontSize: "16px",
                                    },
                                });
                                return;
                            }
                        },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(fluidInput?.waterCut)) return false;
                            updateWaterCut(e?.target?.value);
                        },
                        value: fluidTab?.waterCut || "",
                    },
                    {
                        label: `${LABELS?.bwpd}`,
                        type: "text",
                        value: fluidInput?.bwpd,
                        unit: `${LABELS?.bpd}`,
                        readOnly: true,
                    },
                    {
                        section: `${LABELS?.oilProperty}`,
                        fields: [
                            {
                                label: "",
                                type: "radioInput",
                                name: `${LABELS?.oilAPI}`,
                                radioName: "oilPropertyAPI",
                                unit: "",
                                required: true,
                                rules: {
                                    required: fluidTab?.oilAPI ? false : "Required",
                                    allowDecimal: true,
                                },
                                options: [
                                    { label: `${LABELS?.oilAPI}`, value: "0" },
                                ],
                                inputValue: fluidTab?.oilAPI || "",
                                radioValue: fluidInput?.hiddenOilIPType || '0',
                                onRadioChange: (e: any) => { updateHiddenOilIpType(e) },
                                onInputChange: (e: any) => {
                                    setFluidTab((prev) => ({ ...prev, oilAPI: e?.target?.value }));
                                },
                                onBlur: (e: any) => {
                                    if (Number(e?.target?.value) === Number(fluidInput?.oilAPI)) return false;
                                    updateOilAPI(e?.target?.value);
                                },
                                checked: fluidInput?.hiddenOilIPType === '0' ? true : false,
                            },
                            {
                                label: "",
                                type: "radioInput",
                                name: `${LABELS?.spGrOil}`,
                                radioName: "oilPropertyAPI",
                                unit: "",
                                required: true,
                                rules: {
                                    required: fluidTab?.spGrOil ? false : "Required",
                                    allowDecimal: true,
                                },
                                options: [
                                    { label: `${LABELS?.spGrOil}`, value: "1" },
                                ],
                                inputValue: fluidTab?.spGrOil || "",
                                radioValue: fluidInput?.hiddenOilIPType,
                                onRadioChange: (e: any) => { updateHiddenOilIpType(e) },
                                onInputChange: (e: any) => {
                                    setFluidTab((prev) => ({ ...prev, spGrOil: e?.target?.value }));
                                },
                                onBlur: (e: any) => {
                                    if (Number(e?.target?.value) === Number(fluidInput?.spGrOil)) return false;
                                    updateSpGrOil(e?.target?.value);
                                },
                                checked: fluidInput?.hiddenOilIPType === '1' ? true : false,
                            },
                        ]
                    },
                    {
                        label: `${LABELS?.oilCut}`,
                        type: "text",
                        value: fluidInput?.oilCut,
                        unit: `${LABELS?.percentage}`,
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.bopd}`,
                        type: "text",
                        value: fluidInput?.bopd,
                        unit: `${LABELS?.bpd}`,
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.averageCompositeSpGr}`,
                        type: "text",
                        value: fluidInput?.averageCombinedSpGr,
                        unit: "",
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.liquidPhaseCompositeSpGr}`,
                        type: "text",
                        value: fluidInput?.liquidPhaseCombinedSpGr?.toString() === "NaN" ? 0 : fluidInput?.liquidPhaseCombinedSpGr,
                        unit: "",
                        readOnly: true,
                    },
                    {
                        label: `${LABELS?.fluidViscosity}`,
                        type: "text",
                        unit: `${LABELS?.fluidViscosityUnit}`,
                        required: true,
                        readOnly: true,
                        value: fluidInput?.fluidViscosity === "NaN" ? "" : fluidInput?.fluidViscosity,
                    },
                ],
            },
            {
                section: `${LABELS?.gasProperties}`,
                fields: [
                    {
                        label: `${LABELS?.gasAvailability}`,
                        type: "select",
                        required: true,
                        rules: {
                            required: fluidInput?.gasAvailblty ? false : "Required",
                        },
                        value: fluidInput?.gasAvailblty,
                        options: [
                            { label: `${LABELS?.yes}`, value: "1", default: fluidInput?.gasAvailblty === "1" ? true : false },
                            { label: `${LABELS?.no}`, value: "0" },
                        ],
                        onChange: (e: any) => {
                            updateGasAvailability(e);
                            if (e === "1") {
                                updateHiddenGasIp("0");
                            } else {
                                updateHiddenGasIp("");
                            }
                        },
                        enableSearch: false,
                    },
                ],
            },
            {
                section: `${LABELS?.gasVolume}`,
                fields: fluidGasVolumeFields?.gasVolumeFields,
            },
            {
                section: "",
                fields: fluidGasVolumeFields?.gasVolumeAdditionalFields,
            },
            {
                section: `${LABELS?.others}`,
                fields: [
                    {
                        label: `${LABELS?.bottomHoleTemp}`,
                        type: "input",
                        unit: `${LABELS?.tempUnit}`,
                        required: true,
                        rules: {
                            required: fluidTab?.bottomHoleTemp ? false : "Required",
                            allowDecimal: true,
                        },
                        value: fluidTab?.bottomHoleTemp || "",
                        onChange: (e: any) => {
                            setFluidTab((prev) => ({ ...prev, bottomHoleTemp: e?.target?.value }));
                        },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(fluidInput?.bottomHoleTemp)) return false;
                            updateBottomHoleTemp(e?.target?.value);
                        },
                    },
                    {
                        label: `${LABELS?.surfaceTemp}`,
                        type: "input",
                        unit: `${LABELS?.tempUnit}`,
                        required: true,
                        rules: {
                            required: fluidTab?.surfaceTemperature ? false : "Required",
                            allowDecimal: true,
                        },
                        value: fluidTab?.surfaceTemperature || "",
                        onChange: (e: any) => {
                            setFluidTab((prev) => ({ ...prev, surfaceTemperature: e?.target?.value }));
                        },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(fluidInput?.surfaceTemperature)) return false;
                            updateSurfaceTemp(e?.target?.value);
                        },
                    },
                ],
            },
            {
                section: `${LABELS?.correlations}`,
                fields: [
                    {
                        label: `${LABELS?.region}`,
                        type: "select",
                        options: regionList,
                        required: true,
                        rules: {
                            required: region ? false : "Required",
                        },
                        value: region || "",
                        onChange: (e: any) => { updateRegion(e); },
                        dropdownDirection: "up"
                    },
                ],
            },
        ],
        jetPump: [
            {
                section: "",
                fields: [
                    {
                        label: `${LABELS?.manufacturer}`,
                        type: "select",
                        options: jetPump?.manufactureList,
                        required: true,
                        rules: {
                            required: jetPump?.manufacturer ? false : 'Required',
                        },
                        onChange: (e: any) => {
                            if (Number(e) === Number(jetPump?.manufacturerId)) return false;
                            else {
                                const manufacturerValue = jetPump?.manufactureList?.find((item: any) => item?.value.toString() === e?.toString());
                                updateManufacturerId(e);
                                updateManufacturerName(manufacturerValue?.label || "");
                                clearNozzleThroat();
                            };
                        },
                        value: jetPump?.manufacturerId?.toString(),
                        enableSearch: false,
                    },
                ],
            },
            {
                section: `${LABELS?.nozzle}`,
                fields: [
                    {
                        label: `${LABELS?.Size}`,
                        type: "select",
                        name: "nozzleSize",
                        options: jetPump?.nozzleList,
                        rules: {
                        },
                        onChange: (e: any) => {
                            const diameterValue = jetPump?.nozzleList?.find((item: any) => item?.value?.toString() === e?.toString());
                            if (jetPump?.nozzleDiameterSize !== null && jetPump?.throatDiameterSize !== "" && diameterValue?.value !== "" && e !== "" && Number(e) > Number(jetPump?.throatDiameterSize)) {
                                showToast("Nozzle diameter must be smaller than throat diameter.", "error");
                                return;
                            } else {
                                updateNozzleValue(diameterValue?.label || "");
                                updateNozzleDiameterSize(e || "");
                                loadNozzleArea();
                            };
                        },
                        // Keep Size selection visible when diameter is edited: match by diameter first, then by last selected size (nozzleValue)
                        value: (() => {
                            const byDiameter = jetPump?.nozzleList?.find((o: any) => String(o?.value) === String(jetPump?.nozzleDiameterSize));
                            if (byDiameter?.value != null) return String(byDiameter.value);
                            const byLabel = jetPump?.nozzleList?.find((o: any) => String(o?.label) === String(jetPump?.nozzleValue));
                            return byLabel?.value != null ? String(byLabel.value) : (jetPump?.nozzleDiameterSize ?? "");
                        })(),
                    },
                    {
                        label: `${LABELS?.diameter}`,
                        name: "nozzleDiameter",
                        type: "input",
                        unit: "in",
                        rules: {
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            if (e?.target?.value === "") {
                                setJetPumpTab((prev) => ({ ...prev, nozzleAreaSize: "" }));
                            }
                            setJetPumpTab((prev) => ({ ...prev, nozzleDiameterSize: e?.target?.value }));
                        },
                        value: jetPumpTab?.nozzleDiameterSize || "",
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(jetPump?.nozzleDiameterSize)) return false;
                            if (e?.target?.value !== ""&& jetPump?.throatDiameterSize !== "" && Number(e?.target?.value) > Number(jetPump?.throatDiameterSize)) {
                                showToast("Nozzle diameter must be smaller than throat diameter.", "error");
                                updateNozzleAreaSize("");
                                updateNozzleDiameterSize("");
                                return;
                            }
                            if (e?.target?.value === "" || e?.target?.value === "0" || e?.target?.value === "0.0" || e?.target?.value === "0.") {
                                updateNozzleAreaSize("");
                                updateNozzleDiameterSize("");
                            } else {
                                updateNozzleDiameterSize(e?.target?.value);
                            }
                            loadNozzleArea();
                        },
                    },
                    {
                        label: `${LABELS?.area}`,
                        type: "text",
                        value: jetPumpTab?.nozzleAreaSize || "",
                        unit: "in²",
                        readOnly: true,
                    },
                ],
            },
            {
                section: `${LABELS?.throat}`,
                fields: [
                    {
                        label: `${LABELS?.Size}`,
                        type: "select",
                        name: "throatSize",
                        rules: {
                        },
                        onChange: (e: any) => {
                            const diameterValue = jetPump?.throatList?.find((item: any) => item?.value?.toString() === e?.toString());
                            if (jetPump?.throatDiameterSize !== null && jetPump?.nozzleDiameterSize !== "" && diameterValue?.value !== "" && e !== "" && Number(e) < Number(jetPump?.nozzleDiameterSize)) {
                                showToast("Throat diameter must be larger than nozzle diameter.", "error");
                                return;
                            } else {
                                updateThroatValue(diameterValue?.label || "");
                                updateThroatDiameterSize(e || "");
                                loadThroatArea();
                            };
                        },
                        options: jetPump?.throatList,
                        // Keep Size selection visible when diameter is edited: match by diameter first, then by last selected size (throatValue)
                        value: (() => {
                            const byDiameter = jetPump?.throatList?.find((o: any) => String(o?.value) === String(jetPump?.throatDiameterSize));
                            if (byDiameter?.value != null) return String(byDiameter.value);
                            const byLabel = jetPump?.throatList?.find((o: any) => String(o?.label) === String(jetPump?.throatValue));
                            return byLabel?.value != null ? String(byLabel.value) : (jetPump?.throatDiameterSize ?? "");
                        })(),
                    },
                    {
                        label: `${LABELS?.diameter}`,
                        name: "throatDiameter",
                        type: "input",
                        unit: "in",
                        rules: {
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            if (e?.target?.value === "") {
                                setJetPumpTab((prev) => ({ ...prev, throatAreaSize: "" }));
                            }
                            setJetPumpTab((prev) => ({ ...prev, throatDiameterSize: e?.target?.value }));
                        },
                        value: jetPumpTab?.throatDiameterSize || "",
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(jetPump?.throatDiameterSize)) return false;
                            if (e?.target?.value !== "" && jetPump?.nozzleDiameterSize !== "" && Number(e?.target?.value) < Number(jetPump?.nozzleDiameterSize)) {
                                showToast("Throat diameter must be larger than nozzle diameter.", "error");
                                updateThroatAreaSize("");
                                updateThroatDiameterSize("");
                                return;
                            }
                            if (e?.target?.value === "" || e?.target?.value === "0" || e?.target?.value === "0.0" || e?.target?.value === "0.") {
                                updateThroatAreaSize("");
                                updateThroatDiameterSize("");
                            } else {
                                updateThroatDiameterSize(e?.target?.value);
                            }
                            loadThroatArea();
                        },
                    },
                    {
                        label: `${LABELS?.area}`,
                        type: "text",
                        value: jetPumpTab?.throatAreaSize || "",
                        unit: "in²",
                        readOnly: true,
                    },
                ],
            },
        ],
        jetPumpRange: [
            {
                section: `${LABELS?.powerFluidType}`,
                field1: [
                    {
                        label: `${LABELS?.powerFluidType}`,
                        type: "select",
                        name: "powerFluidType",
                        required: false,
                        rules: {
                            required: false,
                        },
                        onChange: (e: any) => {
                            updatePowerFluidType(e);
                            if (e === "1") {
                                updatePowerFluidDensity(Number(fluidInput?.oilAPI));
                            } else {
                                updatePowerFluidDensity(Number(fluidInput?.spGrWater));
                            }
                        },
                        value: jetPump?.powerFluidType || "1",
                        options: Array.isArray(jetPump?.powerFluidTypeList) ? jetPump?.powerFluidTypeList : [],
                        enableSearch: false,
                    },
                ],
                field2: [
                    {
                        label: `${LABELS?.minimum}`,
                        type: "input",
                        name: "Min power fluid pressure",
                        placeholder: "Enter min",
                        required: true,
                        rules: {
                            required: jetPump?.minFluidRange ? false : 'Required',
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            const minVal = Number(e?.target?.value);
                            if (e?.target?.value === "") {
                                updateStepFluidRange("");
                                updateOutputPressure("");
                            } else if (minVal && jetPump?.maxFluidRange) {
                                const calculatedStep = Math.floor((+jetPump.maxFluidRange - minVal) / 3);
                                updateStepFluidRange(calculatedStep);
                                updateOutputPressure(generateRange(+minVal, +jetPump?.maxFluidRange, +calculatedStep)?.join(", "));
                            };
                            updateMinPowerFluidPressure(e?.target?.value);
                        },
                        value: jetPump?.minFluidRange,
                        className: "w-full",
                    },
                    {
                        label: `${LABELS?.step}`,
                        type: "input",
                        name: "Step",
                        placeholder: "",
                        required: true,
                        rules: {
                            required: "",
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            const val = e?.target?.value;
                            updateStepFluidRange(val);
                        },
                        value: jetPump?.stepFluidRange || "",
                        className: "w-full",
                        disabled: true,
                    },
                    {
                        label: `${LABELS?.maximum}`,
                        type: "input",
                        name: "Max power fluid pressure",
                        placeholder: "Enter max",
                        required: true,
                        rules: {
                            required: jetPump?.maxFluidRange ? false : 'Required',
                            allowDecimal: true,
                        },
                        onChange: (e: any) => {
                            const maxVal = Number(e?.target?.value);
                            if (e?.target?.value === "") {
                                updateStepFluidRange("");
                                updateOutputPressure("");
                            } else if (jetPump?.minFluidRange && maxVal) {
                                const calculatedStep = Math.floor((maxVal - +jetPump.minFluidRange) / 3);
                                updateStepFluidRange(calculatedStep);
                                updateOutputPressure(generateRange(+jetPump?.minFluidRange, +maxVal, +calculatedStep)?.join(", "));
                            };
                            updateMaxPowerFluidPressure(e?.target?.value);
                        },
                        value: jetPump?.maxFluidRange,
                        className: "w-full",
                    },
                ],
                field3: [
                    {
                        label: `${LABELS?.powerFluidDensity}`,
                        type: "input",
                        name: "powerFluidDensity",
                        required: false,
                        rules: {
                            required: false,
                            allowDecimal: true,
                        },
                        value: jetPump?.powerFluidType === "2" ? fluidInput?.oilAPI : jetPump?.powerFluidType === "1" ? fluidInput?.spGrWater : fluidInput?.spGrWater || "",
                        disabled: true,
                        unit: jetPump?.powerFluidType === "2" ? "API" : jetPump?.powerFluidType === "1" ? "sg" : "sg",
                    },
                ],
                field4: [
                    {
                        label: `${LABELS?.outputPressures}`,
                        type: "text",
                        value: jetPump?.minFluidRange && jetPump?.maxFluidRange && jetPump?.stepFluidRange && jetPump?.outputPressures ? jetPump?.outputPressures : "",
                        enabled: jetPump?.minFluidRange && +jetPump?.minFluidRange > 0 && jetPump?.maxFluidRange && +jetPump?.maxFluidRange > 0 ? true : false,
                        unit: `${LABELS?.psi}`,
                    }
                ]
            },
        ],
        jetPumpGasVent: [
            {
                section: "",
                fields: [
                    {
                        label: `${LABELS?.pumpSettingVerticalDepth}`,
                        name: `${LABELS?.pumpSettingVerticalDepth}`,
                        type: "input",
                        required: true,
                        rules: {
                            required: (wellTab?.pumpSettingVerticalDepth && wellTab?.pumpSettingVerticalDepth !== 0) ? false : 'Required',
                            allowDecimal: true,
                            pattern: {
                                value: /^\d*\.?\d*$/,
                                message: `${LABELS?.numberError}`,
                            },
                        },
                        onChange: (e: any) => { setWellTab((prev) => ({ ...prev, pumpSettingVerticalDepth: e?.target?.value })); },
                        onBlur: (e: any) => {
                            if (Number(e?.target?.value) === Number(wellInput?.tvd)) return false;
                            updatePumpSettingVerticalDepth(e?.target?.value);
                        },
                        value: wellTab?.pumpSettingVerticalDepth || "",
                        unit: `${LABELS?.ft1}`
                    },
                    {
                        label: `${LABELS?.gasVented}`,
                        type: "input",
                        name: `${LABELS?.gasVented}`,
                        rules: {
                            required: false,
                            allowDecimal: true,
                        },
                        onChange: (e: any) => { updateGasVent(e?.target?.value); },
                        value: jetPump?.gasVent || "",
                        unit: `%`,
                    }
                ]
            }
        ],
        others: [
            {
                section: `${LABELS?.powerConditions}`,
                fields: [
                    {
                        label: `${LABELS?.supplyPower}`,
                        type: "select",
                        rules: {},
                        options: Array.isArray(othersInput?.suplPwrList) ? othersInput?.suplPwrList : [],
                        value: othersInput?.suplPwrListVal?.toString() || "",
                        onChange: (e: any) => { updateSupplyPower(e) },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.supplyVoltage}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,
                        },
                        value: othersInput?.suplVlt || "",
                        onChange: (e: any) => { updateSupplyVoltage(e?.target?.value); },
                    },
                    {
                        label: `${LABELS?.availableKVA}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,

                        },
                        value: othersInput?.availKVA?.toString() || "",
                        onChange: (e: any) => { updateAvailableKVA(e?.target?.value); },
                    },
                    {
                        label: `${LABELS?.controller}`,
                        type: "select",
                        rules: {},
                        options: Array.isArray(othersInput?.contrlList) ? othersInput?.contrlList : [],
                        value: othersInput?.unitContrlListVal?.toString() || "",
                        onChange: (e: any) => { updateController(e); },
                        enableSearch: false,
                    },
                ],
            },
            {
                section: `${LABELS?.gasImpurities}`,
                fields: [
                    {
                        label: `${LABELS?.oxygen}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,

                        },
                        value: othersInput?.oxygenVal || "",
                        unit: `${LABELS?.percentage}`,
                        onChange: (e: any) => { updateOxygen(e?.target?.value); },
                    },
                    {
                        label: `${LABELS?.nitrogen}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,

                        },
                        value: othersInput?.nitrogenVal || "",
                        unit: `${LABELS?.percentage}`,
                        onChange: (e: any) => { updateNitrogen(e?.target?.value); },
                    },
                    {
                        label: `${LABELS?.h2s}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,

                        },
                        value: othersInput?.h2S || "",
                        unit: `${LABELS?.percentage}`,
                        onChange: (e: any) => { updateH2S(e?.target?.value); },
                    },
                    {
                        label: `${LABELS?.co2}`,
                        type: "input",
                        rules: {
                            required: "",
                            allowDecimal: true,

                        },
                        value: othersInput?.cO2 || "",
                        unit: `${LABELS?.percentage}`,
                        onChange: (e: any) => { updateCO2(e?.target?.value); },
                    },
                ],
            },
            {
                section: `${LABELS?.problemsConcerns}`,
                fields: [
                    {
                        label: `${LABELS?.corrosion}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.unitCorsnListVal === "Yes" ? "1" : othersInput?.unitCorsnListVal === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateCorrosion("No");
                            } else updateCorrosion("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.paraffin}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.paraffin === "Yes" ? "1" : othersInput?.paraffin === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateParaffin("No");
                            } else updateParaffin("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.scale}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.scale === "Yes" ? "1" : othersInput?.scale === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateScale("No");
                            } else updateScale("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.sandSolids}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.sandSolids === "Yes" ? "1" : othersInput?.sandSolids === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateSandSolids("No");
                            } else updateSandSolids("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.viscosityEmulsion}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.viscostyEmulsn === "Yes" ? "1" : othersInput?.viscostyEmulsn === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateViscosityEmulsion("No");
                            } else updateViscosityEmulsion("Yes");
                        },
                        enableSearch: false,
                    },
                ],
            },
            {
                section: `${LABELS?.others}`,
                fields: [
                    {
                        label: `${LABELS?.packerRequired}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.packerReqd === "Yes" ? "1" : othersInput?.packerReqd === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updatePacker("No");
                            } else updatePacker("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.chemical}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.chemicalYN === "Yes" ? "1" : othersInput?.chemicalYN === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateChemical("No");
                            } else updateChemical("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.yTool}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.yToolYN === "Yes" ? "1" : othersInput?.yToolYN === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateYTool("No");
                            } else updateYTool("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.scdaCompatibility}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.scadayn === "Yes" ? "1" : othersInput?.scadayn === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updateScdaCompatibility("No");
                            } else updateScdaCompatibility("Yes");
                        },
                        enableSearch: false,
                    },
                    {
                        label: `${LABELS?.pressureSensor}`,
                        type: "select",
                        rules: {},
                        options: yesNo || [],
                        value: othersInput?.pressureSensYN === "Yes" ? "1" : othersInput?.pressureSensYN === "No" ? "0" : "",
                        onChange: (e: any) => {
                            if (e === "0") {
                                updatePressureSensor("No");
                            } else updatePressureSensor("Yes");
                        },
                        enableSearch: false,
                    },
                ],
            },
            {
                section: `${LABELS?.notes}`,
                fields: [
                    {
                        label: `${LABELS?.addNotes}`,
                        type: "textarea",
                        rules: {
                            required: "",
                            maxLength: {
                                value: 100,
                                message: "Text should not exceed."
                            },
                        },
                        value: othersInput?.additnalNotes || "",
                        rows: 3,
                        onChange: (e: any) => { updateNotes(e); },
                    },
                ]
            },
        ]
    }

    const renderField = (
        field: any,
        form: { [key: string]: string },
        handleChange: (label: string, value: any) => void,
        register: ReturnType<typeof useFormContext>["register"],
        control: any,
    ) => {
        if (field?.type === "select") {
            const fieldName = field?.name || field?.label;
            const selectPlaceholderLabel = field?.label ? `Select ${field.label}` : "-Select-";
            return (
                <Controller
                    name={fieldName}
                    control={control}
                    rules={field?.rules}
                    render={({ field: formField, fieldState: { error } }) => (
                        <Select
                            options={field?.options}
                            name={fieldName}
                            label={field?.label}
                            placeholder={field?.placeholder ?? selectPlaceholderLabel}
                            value={field.value}
                            required={field?.required}
                            isSearch={field?.enableSearch}
                            showCloseIcon={field?.enableDeselect}
                            isNotFound={!!error}
                            onChange={field?.onChange}
                            dropdownDirection={field?.dropdownDirection}
                            enableSearch={field?.enableSearch}
                        />
                    )}
                />
            );
        }
        if (field?.type === "input" || field?.type === "number") {
            const fieldName = field?.name || field?.label;
            return (
                <Controller
                    name={fieldName}
                    control={control || {}}
                    rules={field?.rules}
                    render={({ field: formField, fieldState: { error } }) => (
                        <TextInput
                            name={fieldName}
                            label={field?.label}
                            type={field?.type === 'number' ? 'number' : 'text'}
                            placeholder={field?.placeholder || `Enter ${field?.label}`}
                            unit={field?.unit}
                            error={error?.message}
                            control={control}
                            rules={field?.rules}
                            required={field?.required}
                            disabled={field?.disabled}
                            onChange={field?.onChange}
                            onBlur={field?.onBlur}
                            value={field?.value}
                        />
                    )}
                />
            );
        }
        if (field?.type === "text") {
            return (
                <div className="flex justify-between items-center">
                    <label className="text-[16px] text-neutral-25">{field?.label}</label>
                    <label className="text-[16px] text-neutral-25">{field?.value} {field?.unit}</label>
                </div>
            );
        }

        if (field?.type === "radio") {
            const fieldName = field?.name || field?.label;
            return (
                <Controller
                    name={fieldName}
                    control={control || {}}
                    rules={field?.rules}
                    render={({ field: formField, fieldState: { error } }) => (
                        <RadioButtonGroup
                            name={fieldName}
                            radioName={fieldName}
                            label={field?.label}
                            options={field?.options}
                            direction={field?.direction}
                            rules={field?.rules}
                            control={control}
                            error={error?.message}
                            value={field?.value}
                            onChange={field?.onChange}
                        />
                    )}
                />
            )
        }

        if (field?.type === "checkbox") {
            const fieldName = field?.name || field?.label;
            return (
                <Controller
                    name={fieldName}
                    control={control || {}}
                    rules={field?.rules}
                    render={({ field: formField, fieldState: { error } }) => (
                        <Checkbox
                            name={fieldName}
                            label={field?.label}
                            control={control}
                            error={error?.message}
                            value={field?.value}
                            onChange={field?.onChange}
                        />
                    )}
                />
            );
        }

        if (field?.type === "radioInput") {
            return (
                <RadioWithInput
                    name={field?.name || field?.label}
                    label={field?.label}
                    radioName={field?.radioName || `${field?.name || field?.label}_radio`}
                    options={field?.options}
                    rules={field?.rules}
                    required={field?.required}
                    onRadioChange={field?.onRadioChange}
                    onInputChange={field?.onInputChange}
                    unit={field?.unit}
                    control={control || {}}
                    radioValue={field?.radioValue}
                    inputValue={field?.inputValue}
                    onInputBlur={field?.onBlur}
                    checked={field?.checked}
                />
            );
        }

        if (field?.type === "textarea") {
            const fieldName = field?.name || field?.label;
            return (
                <Controller
                    name={fieldName}
                    control={control || {}}
                    rules={field?.rules}
                    render={({ field: formField, fieldState: { error } }) => (
                        <Textarea
                            name={fieldName}
                            label={field?.label}
                            placeholder={field?.placeholder || "Write here"}
                            rules={field?.rules}
                            rows={field?.rows}
                            control={control}
                            error={error?.message}
                            value={field?.value}
                            onChange={field?.onChange}
                        />
                    )}
                />
            );
        }

        if (field?.section !== "") {
            return (
                <Accordion
                    title={field?.section}
                    isOpen={getdefaultCollapse(field?.section) ?? false}
                    onToggle={() => handleCollapseChange(!getdefaultCollapse(field?.section), field?.section)}
                    content={
                        <div className="flex flex-col gap-[16px] p-[12px]">
                            {field?.fields?.map((field: any, idx: number) => (
                                <div key={idx}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                        </div>
                    }
                />
            )
        };
        return null;
    };

    const tubingInstallSectionRenderFields = (
        section: any,
        form: { [key: string]: string },
        handleChange: (label: string, value: any) => void,
        register: ReturnType<typeof useFormContext>["register"],
        control: any,
        tubingInstallationType: string,
    ) => {
        if (section === LABELS?.tubing) {
            return (
                <Accordion
                    title={section}
                    isOpen={getdefaultCollapse(section) ?? false}
                    onToggle={() => handleCollapseChange(!getdefaultCollapse(section), section)}
                    content={
                        <div className="flex flex-col gap-[16px] p-[12px]">
                            {sectionsData?.tubingInstallType?.map((field: any) => {
                                return (
                                    renderField(field, form, handleChange, register, control)
                                )
                            })}
                            {tubingInstallationType === "2" && sectionsData?.tubingParallelProductionFlow?.map((field: any, idx: number) => (
                                <div key={idx}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                            <Accordion
                                title={`${tubingInstallationType === "2" ? `${LABELS?.parallelTubing1}` : tubingInstallationType === "3" ? `${LABELS?.concentricTubing1}` : `${LABELS?.tubing1}`}`}
                                onToggle={() => handleCollapseChange(!getdefaultCollapse("Tubing - 1"), "Tubing - 1")}
                                isOpen={getdefaultCollapse("Tubing - 1") ?? false}
                                content={<>
                                    {sectionsData?.tubing1Section?.map((field: any, idx: number) => (
                                        <div key={idx} className="flex flex-col gap-[16px] p-[12px]">
                                            {renderField(field, form, handleChange, register, control)}
                                        </div>
                                    ))}
                                </>}
                            />
                            {(tubingInstallationType === "3" || tubingInstallationType === "2") && <Accordion
                                title={`${tubingInstallationType === "2" ? `${LABELS?.parrallelTubing2}` : tubingInstallationType === "3" ? `${LABELS?.concentricTubing2}` : `${LABELS?.tubing2}`}`}
                                onToggle={() => handleCollapseChange(!getdefaultCollapse("Tubing - 2"), "Tubing - 2")}
                                isOpen={getdefaultCollapse("Tubing - 2") ?? false}
                                content={<>
                                    {sectionsData?.tubing2Section?.map((field: any, idx: number) => (
                                        <div key={idx} className="flex flex-col gap-[16px] p-[12px]">
                                            {renderField(field, form, handleChange, register, control)}
                                        </div>
                                    ))}
                                </>}
                            />}
                            {sectionsData?.tubingTrajectory?.map((field: any) => (
                                renderField(field, form, handleChange, register, control)
                            ))}
                        </div>
                    }
                />
            )
        }
        return null;
    };

    const wellIPRrenderFields = (
        section: any,
        form: { [key: string]: string },
        handleChange: (label: string, value: any) => void,
        register: ReturnType<typeof useFormContext>["register"],
        control: any,
        inflowType: string,
    ) => {
        if (section === LABELS?.iprType) {
            return (
                <Accordion
                    title={section}
                    isOpen={getdefaultCollapse(section) ?? false}
                    onToggle={() => handleCollapseChange(!getdefaultCollapse(section), section)}
                    content={
                        <div className="flex flex-col gap-[16px] p-[12px]">
                            {wellIprTypes?.inflowTypeFields?.map((field: any) => {
                                return (
                                    renderField(field, form, handleChange, register, control)
                                )
                            })}
                            {inflowType === "0" && wellIprTypes?.wellIPRPIInputs?.map((field: any, idx: number) => (
                                <div key={idx}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                            {inflowType === "1" && wellIprTypes?.wellIPRPInpus?.map((field: any, idx: number) => (
                                <div key={idx}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                            {inflowType === "2" && wellIprTypes?.wellIPRHeadInputs?.map((field: any, idx: number) => (
                                <div key={idx}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                            {wellIprTypes?.desrdProductionFields?.map((field: any) => (
                                renderField(field, form, handleChange, register, control)
                            ))}
                        </div>
                    }
                />
            )
        }
        return null;
    };

    const fluidGasVolumeRenderFields = (
        section: any,
        form: { [key: string]: string },
        handleChange: (label: string, value: any) => void,
        register: ReturnType<typeof useFormContext>["register"],
        control: any,
        fluidData: Record<string, any> | undefined,
    ) => {
        if (section === LABELS?.gasVolume) {
            return (
                <Accordion
                    title={section}
                    isOpen={getdefaultCollapse(section) ?? false}
                    onToggle={() => handleCollapseChange(!getdefaultCollapse(section), section)}
                    content={
                        <div className="flex flex-col gap-[16px] p-[12px]">
                            {fluidGasVolumeFields?.gasVolumeFields?.map((field: any, idx: number) => (
                                <div key={`gas-volume-${idx}`}>
                                    {renderField(field, form, handleChange, register, control)}
                                </div>
                            ))}
                            {fluidGasVolumeFields?.gasVolumeAdditionalFields?.map((field: any, idx: number) => {
                                const dependencyValue = field?.dependsOn
                                    ? fluidData?.[field.dependsOn as string]
                                    : undefined;
                                const shouldRender = !field?.dependsOn
                                    || dependencyValue === undefined
                                    || dependencyValue === field?.visibleWhen;
                                if (!shouldRender) {
                                    return null;
                                }
                                return (
                                    <div key={`gas-volume-additional-${idx}`}>
                                        {renderField(field, form, handleChange, register, control)}
                                    </div>
                                );
                            })}
                        </div>
                    }
                />
            )
        }
        return null;
    };

    return {
        sectionsData,
        renderField,
        tubingInstallSectionRenderFields,
        wellIPRrenderFields,
        fluidGasVolumeRenderFields,
    }
};

export default useInputValidations;